import customFetch from '@/lib/customFetch';

const API_URL = process.env.VUE_APP_MACHETE_OPS_API;

const CLIENT_SAVE = `${API_URL}/company/:id/client`;
const CLIENT_GET = `${API_URL}/company/:id/clients`;

export default {
  async saveClient(id, body) {
    const response = await customFetch(CLIENT_SAVE, {
      method: 'POST',
      params: { id },
      body: JSON.stringify(body),
    });

    const { payload } = await response.json();
    return payload;
  },
  async getClient(id) {
    const response = await customFetch(CLIENT_GET, {
      method: 'GET',
      params: { id },
    });

    const { payload } = await response.json();
    return payload;
  },
};
